export default "__VITE_ASSET__517c69f8__"